(function() {
	/**
	 * Renders FAQ detail page: [FAQ Item]
	 * @param {Object} props - The Routing and page context and properties
	 * @returns {object} 	Promise with data (nav for menu, etc.)
	 */
	WebBaseAprovLV.renderFaqPage = function(props) {
		var params = {
			page: props.context.params.page || '',
			detail: props.context.params.detail || ''
		};
		var model = {
			element: null,
			template: 'templates/faq.ejs.html?v=' + WebBaseAprovLV.version.template,
			data: {
				main: (props.context.Model || {}).Main || {}, /* Comes from renderMainContent() */
				pageRaw: null,
				navRaw: null,
				faq: null,
				faqRaw: null,
				related: [],
				nav: null,
				pageContent: null
			}
		};
		return $.when(
			// WebBaseAprovLV.Utils.getKKData('?system.type=page&system.codename[in]=faq_item'),
			WebBaseAprovLV.Utils.getKKData('?system.type=page&elements.url[in]=' + params.page + '&depth=1'),
			WebBaseAprovLV.Utils.getKKData('?system.type=faq_item&elements.url[in]=' + params.detail),
			ejs.preloadTemplate(model.template),
			ejs.preloadTemplate('templates/breadcrumb.ejs.html?v=' + WebBaseAprovLV.version.template),
			ejs.preloadTemplate('templates/bottomnav.ejs.html?v=' + WebBaseAprovLV.version.template)
		).then(function(pageXhr, faqXhr, tmplPage, tmplBreadcrumb, tmplBottomnav) {
			var pageRaw = Array.isArray(pageXhr) && pageXhr.length ? pageXhr[0] : (pageXhr || {});
			var faqRaw = Array.isArray(faqXhr) && faqXhr.length ? faqXhr[0] : (faqXhr || {});
			var categoryQueryNames = [];
			var categoryQueryString = '';
			model.data.navRaw = {};
			model.data.pageRaw = pageRaw;
			model.data.faqRaw = faqRaw;
			model.element = $('#content');
			model.data = $.extend(model.data, {
				pageContent: WebBaseAprovLV.Utils.getKKViewModel(model.data.pageRaw)[0] || {},
				nav: WebBaseAprovLV.Utils.getKKViewModel(model.data.navRaw)[0] || {},
				faq: WebBaseAprovLV.Utils.getKKViewModel(model.data.faqRaw)[0] || {}
			});
			categoryQueryNames = (model.data.faq.faq_categories || []).map(function(c) {
				return c.codename || '';
			});
			if (categoryQueryNames.length) {
				categoryQueryString = '&elements.faq_categories';
				if (categoryQueryNames.length === 1) {
					categoryQueryString += '[contains]=' + encodeURIComponent(categoryQueryNames[0]);
				} else if (categoryQueryNames.length > 1) {
					categoryQueryString += '[any]=' + encodeURIComponent(categoryQueryNames.join(','));
				}
			}
			if (model.data.faq.system_codename) {
				return WebBaseAprovLV.Utils.getKKData('?system.type=faq_item&includeTotalCount=false&system.codename[neq]=' + model.data.faq.system_codename + categoryQueryString + '&order=elements.date[desc]&depth=1&limit=3');
			}
			return {};
		}).then(function(relatedXhr) {
			model.data.related = (relatedXhr.items || []).length ? WebBaseAprovLV.Utils.getKKViewModel(relatedXhr) || [] : [];
			return WebBaseAprovLV.Utils.transitionTo(model);
		}).then(function(ejsmodel) {
			ejsmodel.data.UILangSwitch = WebBaseAprovLV.Utils.tuneUILangSwitchers({
				page: {
					id: ((ejsmodel.data.pageContent || {}).system_id || ''),
					segment: 'faq'
					/* segment: {
						'de': 'faq',
						'it': 'faq',
						'lld': 'faq'
					} */
				},
				detail: {
					id: ((ejsmodel.data.faq || {}).system_id || '')
				}
			}, $('a.langchange'));
			return ejsmodel;
		}).promise();
	};
})();
